import { render, staticRenderFns } from "./donor-my-teams-stats.vue?vue&type=template&id=dddf43c4&scoped=true&"
import script from "./donor-my-teams-stats.vue?vue&type=script&lang=js&"
export * from "./donor-my-teams-stats.vue?vue&type=script&lang=js&"
import style0 from "./donor-my-teams-stats.vue?vue&type=style&index=0&id=dddf43c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddf43c4",
  null
  
)

export default component.exports